import React from "react";

const CARDS = [
  {
    id: "authority-journey",
    title: "Open Storybook 01: Authority Journey",
    body:
      "See an illustrative cross-organisation decision move from stalled exception to governed, receipt-backed outcome.",
    href: "https://authority-journey.katlastechnology.com/",
    accent: "blue",
  },
  {
    id: "cierge-labs",
    title: "Apply it in Cierge Labs",
    body:
      "Bring a real handover, exception or decision into an applied journey, discovery and pilot environment.",
    href: "https://labs.katlastechnology.com/",
    accent: "blue",
  },
  {
    id: "pilot",
    title: "Discuss a focused pilot",
    body:
      "Explore a bounded demonstrator or operational deployment pathway.",
    href: "https://www.katlastechnology.com/contact/",
    accent: "amber",
  },
];

export const ChooseYourNextStep = () => {
  return (
    <section
      id="choose-next-step"
      data-testid="section-choose-next-step"
      className="relative py-20 lg:py-28 border-t border-white/[0.06] bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
            Next step
          </div>
          <h2
            data-testid="choose-next-step-headline"
            className="font-display text-3xl sm:text-4xl lg:text-[44px] mt-4 leading-[1.08]"
          >
            Take the pattern{" "}
            <span className="text-slate-400">into context.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06]">
          {CARDS.map((c) => (
            <a
              key={c.id}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`next-step-${c.id}`}
              className="group bg-[#040F1B] p-6 lg:p-7 flex flex-col hover:bg-[#061322] transition-colors"
            >
              <h3
                className={`font-display text-lg sm:text-xl leading-snug ${
                  c.accent === "amber"
                    ? "text-[#EAB308]"
                    : "text-white"
                }`}
              >
                {c.title}
              </h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed flex-1">
                {c.body}
              </p>
              <div className="mt-6 pt-4 border-t border-white/[0.06] flex items-center justify-between">
                <span className="mono text-[10px] uppercase tracking-[0.22em] text-slate-500 group-hover:text-slate-300 transition-colors">
                  Open
                </span>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className={`${
                    c.accent === "amber"
                      ? "text-[#EAB308]"
                      : "text-[#0066FF]"
                  } group-hover:translate-x-0.5 transition-transform`}
                >
                  <path d="M7 17 17 7M8 7h9v9" />
                </svg>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
